import React, { Component } from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import ListItem from "@material-ui/core/ListItem";
import Axios from "axios";

import LibraryIcon from "../../../../../Assets/Logo/LibraryIcon.svg";
import { url } from "../../../../../Config/Config";
import { useStyles } from "../StudentDashboard.css";
import { getUserRefreshToken } from "../../../../../Redux/Actions/actions";

class StudentLibraryCard extends Component {
  constructor(props) {
    super(props);
    this.state = { bookIssuedCount: 0, bookReturnCount: 0 };
  }

  componentDidMount() {
    this.getLibrary();
  }

  getLibrary = async () => {
    try {
      const response = await Axios.get(`${url}/api/books`, {
        headers: {
          Authorization: `Bearer ${this.props.userToken}`,
        },
      });
      if (response.data.books.length !== 0) {
        this.setState({
          books: response.data.books,
          isEmpty: false,
        });
      } else {
        this.setState({
          books: [],
          isEmpty: true,
        });
      }
      let issued = [];
      for (let i = 0; i <= response.data.books.length - 1; i++) {
        for (let j = 0; j <= response.data.books[i].loans.length - 1; j++) {
          if (response.data.books[i].loans[j].studentId === this.props.userId) {
            issued.push(response.data.books[i].loans[j]);
          }
        }
      }
      let bookIssuedCount = issued.length;
      let bookReturnCount = issued.filter((data) => data.returnDate).length;
      this.setState({
        bookIssuedCount,
        bookReturnCount,
      });
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.userRefreshToken };
        this.props.getUserRefreshToken(refreshToken, this.props.role);
        this.getLibrary();
      }
    }
  };

  render() {
    const { classes } = this.props;
    const { bookIssuedCount, bookReturnCount } = this.state;
    return (
      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
        <Paper>
          <ListItem>
            <img
              src={LibraryIcon}
              alt="library"
              style={{ width: 40, height: 40 }}
            />
            <div>Library</div>
          </ListItem>
          <div className={classes.listitemRoot}>
            <ListItem>
              <b style={{ flexGrow: 1 }}>Books Issued:</b> {bookIssuedCount}
            </ListItem>
            <ListItem>
              <b style={{ flexGrow: 1 }}>Book Returned:</b> {bookReturnCount}
            </ListItem>
          </div>
        </Paper>
      </Grid>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userId: state.UserReducer.userId,
    userToken: state.UserReducer.userToken,
    userRefreshToken: state.UserReducer.userRefreshToken,
    role: state.UserReducer.role,
    isUser: state.UserReducer.isUser,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getUserRefreshToken: (refreshToken, role) => {
      dispatch(getUserRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(StudentLibraryCard));
